export const UPDATE = "users/UPDATE";
export const UPDATE_ONE = "users/UPDATE_ONE";
export const APPEND = "users/APPEND";
export const EMPTY = "users/EMPTY";
export const LOADING = "users/LOADING";
